import { render } from "./RoomCategory.vue?vue&type=template&id=2f43d0f8"
import script from "./RoomCategory.vue?vue&type=script&lang=js"
export * from "./RoomCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__